import React from 'react';
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Box,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  Flex,
    RadioGroup,
    Radio,
    Stack,
} from '@chakra-ui/react';

const DDMAnalysis = ({
    analysisModels,
    handleParameterChange,
    calculateModel,
    loading,
    stockData,
    formatCurrency,
    handleModelTypeChange,
}) => {
    return (
        <VStack spacing={4} align="stretch">
            <FormControl as="fieldset">
                <FormLabel as="legend">Seleziona il Modello DDM</FormLabel>
                <RadioGroup
                name="modelType"
                value={analysisModels.DDM.parameters.modelType}
                onChange={(value) => handleModelTypeChange('DDM', value)}
                >
                <Stack direction="row">
                    <Radio value="Gordon">Gordon</Radio>
                    <Radio value="Multiple">Multiple-Period</Radio>
                </Stack>
                </RadioGroup>
            </FormControl>
            <FormControl id="dividendGrowthRate" isRequired>
                <FormLabel>Tasso di crescita dei dividendi (%)</FormLabel>
                <Input
                type="number"
                name="dividendGrowthRate"
                value={analysisModels.DDM.parameters.dividendGrowthRate}
                onChange={(e) => handleParameterChange('DDM', e)}
                placeholder="Es. 2.5"
                />
            </FormControl>
            <FormControl id="requiredReturnRate" isRequired>
                <FormLabel>Tasso di rendimento richiesto (%)</FormLabel>
                <Input
                type="number"
                name="requiredReturnRate"
                value={analysisModels.DDM.parameters.requiredReturnRate}
                onChange={(e) => handleParameterChange('DDM', e)}
                placeholder="Es. 7.0"
                />
            </FormControl>
            {analysisModels.DDM.parameters.modelType === 'Multiple' && (
                <FormControl id="forecastYears" isRequired>
                <FormLabel>Anni di Forecast</FormLabel>
                <Input
                    type="number"
                    name="forecastYears"
                    value={analysisModels.DDM.parameters.forecastYears}
                    onChange={(e) => handleParameterChange('DDM', e)}
                    placeholder="Es. 5"
                />
                </FormControl>
            )}
            <Button
                colorScheme="green"
                onClick={() => calculateModel('DDM')}
                isLoading={loading}
            >
                Calcola DDM
            </Button>
            {analysisModels.DDM.stockValue !== null && (
                <Box>
                {analysisModels.DDM.parameters.modelType === 'Multiple' && (
                <>
                    <Text mt={2} fontSize="sm" fontWeight="semibold">
                    Forecast anno per anno:
                    </Text>
                    <Table variant="simple" size="sm" mt={2}>
                    <Thead>
                        <Tr>
                        <Th>Anno</Th>
                        <Th>Dividendo Forecast</Th>
                        <Th>Valore Attualizzato</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {analysisModels.DDM.forecast.map((item) => (
                        <Tr key={item.year}>
                            <Td>{item.year}</Td>
                            <Td>{formatCurrency(item.forecastDividend, stockData.currency)}</Td>
                            <Td>{formatCurrency(item.discountedDividend, stockData.currency)}</Td>
                        </Tr>
                        ))}
                    </Tbody>
                    </Table>
                </>
                )}
                <Flex minWidth='max-content' gap='4' pt='4'>
                    <Box flex='1' p='4' borderWidth='1px' borderRadius='lg' boxShadow='md'>
                        <Text fontSize="lg" fontWeight="bold" mb='4'>Valutazione finale del Titolo</Text>
                        <Text mt={2} fontSize="sm" fontWeight="semibold">Stock Value (SV): {formatCurrency(analysisModels.DDM.stockValue, stockData.currency)}</Text>
                        <Text mt={4} fontSize="sm" fontWeight="semibold">Current Stock Price: {formatCurrency(stockData.currentPrice, stockData.currency)}</Text>
                        <Text mt={2} fontSize="sm" fontWeight="semibold" color={analysisModels.DDM.stockValue > stockData.currentPrice ? 'green.500' : 'red.500'}>
                            {analysisModels.DDM.stockValue > stockData.currentPrice ? 'Undervalued' : 'Overvalued'} by {formatCurrency(Math.abs(analysisModels.DDM.stockValue - stockData.currentPrice), stockData.currency)} ({((analysisModels.DDM.stockValue / stockData.currentPrice - 1) * 100).toFixed(2)}%)
                        </Text>
                    </Box>
                    <Divider orientation='vertical' mt={4}/>
                    <Box flex='1' p='4' borderWidth='1px' borderRadius='lg' boxShadow='md'>
                        <Text fontSize="lg" fontWeight="bold" mb='4'>Equazioni utilizzate</Text>
                        
                    </Box>
                </Flex>
                </Box>
            )}
        </VStack>
  );
};

export default DDMAnalysis;